import React, { Component, createRef, useState, useEffect } from "react";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";

const NEW_BILLING_STATUS_CATEGORY_BASE_STATE = { name: "" };

function BillingStatusCategories(props) {
  const [billingStatusCategories, setBillingStatusCategories] = useState([]);
  const [filteredBillingStatusCategories, setFilteredBillingStatusCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);

  const [selectedBillingStatusCategory, setSelectedBillingStatusCategory] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newBillingStatusCategory, setNewBillingStatusCategory] = useState(NEW_BILLING_STATUS_CATEGORY_BASE_STATE);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "Billing Statuses Using This Category",
      dataIndex: "applicable_statuses",
      key: "applicable_statuses",
      render: (text) => <Tooltip title={text}>{_.truncate(text, { separator: ", ", length: 128 })}</Tooltip>,
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              setEditModalOpen(true);
              setSelectedBillingStatusCategory(billingStatusCategories.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedBillingStatusCategory(billingStatusCategories.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetBillingStatusCategories = async () => {
    let response = await props.AxiosRequest("/api/billing-status-categories/get");
    setBillingStatusCategories(response.data.billing_status_categories);
    setFilteredBillingStatusCategories(response.data.billing_status_categories);
  };
  const UpdateBillingStatusCategory = async () => {
    await props.AxiosRequest("/api/billing-status-categories/update", { id: selectedBillingStatusCategory.id, name: selectedBillingStatusCategory.name });
    GetBillingStatusCategories();
    setEditModalOpen(false);
    setSelectedBillingStatusCategory(null);
  };
  const DeleteBillingStatusCategory = async () => {
    await props.AxiosRequest("/api/billing-status-categories/delete", { id: selectedBillingStatusCategory.id });
    GetBillingStatusCategories();
    setDeleteModalOpen(false);
    setSelectedBillingStatusCategory(null);
  };
  const AddBillingStatusCategory = async () => {
    if (newBillingStatusCategory.name.length === 0) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/billing-status-categories/insert", { name: newBillingStatusCategory.name });
    GetBillingStatusCategories();
    setAddModalOpen(false);
    setNewBillingStatusCategory(NEW_BILLING_STATUS_CATEGORY_BASE_STATE);
  };

  useEffect(() => {
    GetBillingStatusCategories();
  }, []);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredBillingStatusCategories(billingStatusCategories);
    let filtered_list = billingStatusCategories.filter((f) => (_.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 ? true : false));
    setFilteredBillingStatusCategories(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Billing Status Categories</h1>
        </div>
        <Row>
          <Card
            title={<>Billing Status Categories</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewBillingStatusCategory(NEW_BILLING_STATUS_CATEGORY_BASE_STATE);
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  Add A New Billing Status Category
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table className="table table-striped hover" columns={table_columns} dataSource={filteredBillingStatusCategories} />
          </Card>
        </Row>
        <Modal
          title={"Edit Billing Status Category"}
          centered
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedBillingStatusCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedBillingStatusCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateBillingStatusCategory();
                }}
              >
                Save Changes
              </Button>
            </>
          }
        >
          {selectedBillingStatusCategory ? (
            <>
              <label className="col-form-label-sm">Billing Status Category Name *</label>
              <Input
                value={selectedBillingStatusCategory.name}
                onChange={(e) => {
                  setSelectedBillingStatusCategory({ ...selectedBillingStatusCategory, name: e.target.value });
                }}
              />
            </>
          ) : null}
        </Modal>

        <Modal
          title={"Are you sure?"}
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedBillingStatusCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedBillingStatusCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteBillingStatusCategory();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedBillingStatusCategory ? <>Are you sure you want to delete the billing status category {selectedBillingStatusCategory?.name}?</> : null}
        </Modal>

        <Modal
          title={"Add A New Billing Status Category"}
          centered
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setSelectedBillingStatusCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedBillingStatusCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddBillingStatusCategory();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newBillingStatusCategory ? (
            <>
              <label className="col-form-label-sm">Billing Status Category Name *</label>
              <Input
                value={newBillingStatusCategory.name}
                onChange={(e) => {
                  setNewBillingStatusCategory({ ...newBillingStatusCategory, name: e.target.value });
                }}
              />
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default BillingStatusCategories;
